import React from 'react';
import OrderReturnList from '../OrderReturnList';
import OrderReturnListSearchBox from '../OrderReturnListSearchBox';
import OrderReturnListSummaryBox from '../OrderReturnListSummaryBox';

const OrderReturnListWrap = (props) => {
  const { setData, orderReturnList, mainProductCategorySelectList, getList, getExcelDownload } = props;

  return (
    <div className="order-return-list-wrap">
      {/* 주문 반품 서머리 데이터 */}
      <OrderReturnListSummaryBox orderReturnSummaryBox={orderReturnList.orderReturnSummaryBox} />

      {/*주문 반품 서치 박스*/}
      <OrderReturnListSearchBox
        setData={(data) =>
          setData({
            path: ['orderReturnList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={orderReturnList.searchData}
        getList={getList}
      />

      {/* 주문 반품 리스트 */}
      <OrderReturnList
        orderReturnList={orderReturnList}
        mainProductCategorySelectList={mainProductCategorySelectList}
        getList={getList}
        getExcelDownload={getExcelDownload}
      />
    </div>
  );
};

export default OrderReturnListWrap;
